import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Image from '../global/Image';
import FadeIn from "react-lazyload-fadein";

export default class PageMrkProjects extends Component {

	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <>
				
					<div className={'c-page__block c-page__block--' + block.space_after + ' c-page__block--load-effect'}>
					
						<div className="c-mrk-listings">
						
							<div className="l-content l-content--fixed-width">
			    				
			    				<div className="l-grid">
			    				
			    					<div className="l-grid__col">
			    					
			    						{block.heading &&
					    					<h2 className="c-mrk-listings__heading" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
				    					}
				    					
				    					{block.ftr_src &&
						    				<div className="c-mrk-listings__image">
						    					<Image srcset={block.ftr_srcset} src={block.ftr_src} width={block.ftr_width} post={block.ftr_height}></Image>
						    				</div>
						    			}
						    			
						    		</div>
						    		
								</div>
								
							</div>
							
							<div className="c-mrk-listings__bg"></div>
							
							<div className="l-content l-content--fixed-width">
			    				
			    				<div className="l-grid">
			    				
			    					<div className="l-grid__col">
			    					
			    						<div className="c-mrk-listings__ftext">
			    							
			    							{block.ftr_heading &&
					    						<h3 className="c-mrk-listings__ftext__heading" dangerouslySetInnerHTML={{__html:block.ftr_heading}}></h3>
				    						}
				    						
				    						{block.ftr_text &&
					    						<div className="scope-text scope-text--faded" dangerouslySetInnerHTML={{__html:block.ftr_text}}></div>
				    						}
				    						
				    						{block.ftr_button_text && block.ftr_button_url &&
					    						<div className="c-mrk-listings__ftext__buttons">
					    							<Link to={block.ftr_button_url} className="c-mrk-listings__ftext__buttons__button" dangerouslySetInnerHTML={{__html:block.ftr_button_text}}></Link>
					    						</div>
				    						}
			    						
			    						</div>
			    					
			    						<div className="c-property-thumbs">
			    							
			    							{block.listing.length === 0 &&
				    							<div className="c-property-thumbs__no-results">
				    								<div className="c-property-thumbs__no-results__inner">
				    									<h3 className="c-property-thumbs__no-results__heading">There are no matching properties</h3>
														<p className="c-property-thumbs__no-results__text">There are properties available that match the criteria you have selected. Please try expanding expanding your search.</p>
				    								</div>
				    							</div>
			    							}
			    							
			    							{block.listing.map((listing,i) => 
												{
													let thumbClass = 'c-property-thumbs__thumb'
													if (listing.featured) {
														thumbClass = thumbClass + ' c-property-thumbs__thumb--featured';
													}
													
													return (
					
														<div className={thumbClass} key={i}>
														
															<Link to={listing.url} className="c-property-thumbs__thumb__link">
																
																<div className="c-property-thumbs__thumb__image">
																	
																	{listing.srcset && 
																		<FadeIn>
																			{onload => (
																				<img
																					alt={""} 
																					src={listing.src} 
																					srcSet={listing.srcset} 
																					onLoad={onload}
																				/>
																			)}
																		</FadeIn>
																	}
																	{!listing.srcset && 
																		<FadeIn>
																			{onload => (
																				<img
																					alt={""} 
																					src={listing.src} 
																					onLoad={onload}
																				/>
																			)}
																		</FadeIn>
																	}
																	
																</div>
																
																<div className="c-property-thumbs__thumb__text">
																
																	<div className={`c-property-thumbs__thumb__text__left c-property-thumbs__thumb__text__left--no-icons ${listing.skistore ? "state-ski-store" : ""}`}>
																		<h3 className="c-paragraph" dangerouslySetInnerHTML={{__html:listing.heading}}></h3>
																		<h4 className="c-paragraph" dangerouslySetInnerHTML={{__html:listing.suburb}}></h4>
																	</div>
																	
																	<div className={`c-property-thumbs__thumb__text__right c-property-thumbs__thumb__text__right--no-icons ${listing.skistore ? "state-ski-store" : ""}`}>
																
											    						
											    						{listing.categories &&
											    						
											    							<p className="c-paragraph c-paragraph--faded" dangerouslySetInnerHTML={{__html:listing.categories}}></p>
											    						
											    						}
											    						
					    						
																	</div>
																	
																	{listing.sold &&
																		<p className="c-property-thumbs__thumb__banner" dangerouslySetInnerHTML={{__html:'Sold'}}></p>
																	}
																	
																	{listing.under_offer &&
																		<p className="c-property-thumbs__thumb__banner" dangerouslySetInnerHTML={{__html:'Under Offer'}}></p>
																	}
																	
																</div>
																
															</Link>
														
														</div>
													
													)
												}
											)}
			    						
			    						</div>
			    						
			    						{block.button_text && block.button_url &&
					    					<div className="c-mrk-listings__buttons">
					    						<Link to={block.button_url} className="c-mrk-listings__buttons__button" dangerouslySetInnerHTML={{__html:block.button_text}}></Link>
					    					</div>
					    				}
			    						
			    					</div>
			    					
			    				</div>
			    				
			    			</div>
		    		
						</div>
		    		
		    		</div>
		    				
		    	</>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
